import { useInstanceKey } from 'app/area/favourite/favourite-context';
import { 
  selectAggregationForSelectedReport, 
  selectTargetApplicationForSelectedReport 
} from 'app/area/favourite/selectors';
import { ReportCommonApi } from 'app/area/reports/types-api';
import { codeItemToStoreValue } from 'app/infrastructure/data/codes';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from './actions';

export function useActionCreators(api: ReportCommonApi) {
  const dispatch = useDispatch();
  const instanceKey = useInstanceKey();
  return useMemo(() => bindActionCreators(actionCreators(api, instanceKey), dispatch), [dispatch, instanceKey]);
}

export function useWorkingDefinitionTargetApplication() {
  const instanceKey = useInstanceKey();
  return codeItemToStoreValue(useSelector(selectTargetApplicationForSelectedReport(instanceKey)));
}

export function useLoadDefaultFieldsEffect(api: ReportCommonApi) {
  const instanceKey = useInstanceKey();

  const {
    loadDefaultFields,
    clearState
  } = useActionCreators(api);

  const {
    aggregationType
  } = useSelector(selectAggregationForSelectedReport(instanceKey));

  useEffect(() => {
    loadDefaultFields();
    return () => {
      clearState();
    };
  }, [aggregationType?.v]);
}
